import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { FormHelperText, Typography, FormGroup, Checkbox } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { MyCheckboxGroupViewProps, CheckboxGroupProps } from './checkboxType'
import useCheckboxGroup from './useCheckbox'
import { makeStyles } from '@material-ui/core/styles'

let MyCheckboxView: React.FC<MyCheckboxGroupViewProps> = ({
    field,
    required,
    disabled = false,
    row = true,
    onChangeValue,
    label,
    onChange,
}) => {
    const { meta, input } = field

    const isError = meta.error && meta.invalid && meta.touched ? true : false
    // const isError = meta.error && meta.invalid ? true : false

    const classes = useStyles(isError)
    const isChecked = input.value && typeof input.value === 'boolean' && input.value === true ? true : false
    const getLabel = () => {
        const myLabel = required ? (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant={'subtitle2'} style={{ color: 'red' }}>
                        *
                    </Typography>
                </Grid>
            </Grid>
        ) : (
            <span className={classes.label}>
                <Typography variant={'subtitle2'}>{label || ''}</Typography>
            </span>
        )
        return <Typography variant={'subtitle2'}>{myLabel}</Typography>
    }
    return (
        <FormControl style={{ width: '100%' }} error={meta.error && meta.touched ? true : false}>
            <FormGroup row={row}>
                <FormControlLabel
                    label={getLabel()}
                    control={
                        <Checkbox
                            {...input}
                            disabled={disabled}
                            required={required ? true : false}
                            classes={{
                                root: isError ? classes.rootError : classes.root,
                                checked: classes.checked,
                                disabled: classes.disabled,
                            }}
                            onChange={(evt: any) => {
                                onChange(evt)
                                if (onChangeValue) {
                                    onChangeValue(evt.target.value)
                                }
                            }}
                            checked={isChecked}
                        />
                    }
                />
            </FormGroup>

            <FormHelperText className={classes.errorText}>{isError && meta.error}</FormHelperText>
        </FormControl>
    )
}

let MyCheckbox: React.FC<CheckboxGroupProps> = ({ name, ...others }) => {
    const myCheckboxGroup = useCheckboxGroup({
        name,
        ...others,
    })
    return <MyCheckboxView {...myCheckboxGroup} {...others} />
}

export default MyCheckbox

const useStyles = makeStyles((theme) => ({
    label: {
        // marginBottom: 10,
        // color: (isError: any) => {
        //     console.log('isError', isError)
        //     if (isError) {
        //         return '#ff4d4f'
        //     } else {
        //         return ''
        //     }
        // },
    },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
    rootError: {
        color: 'red',
        '&$checked': {
            color: '#db5f8e',
        },
    },

    root: {
        color: '#848484',
        '&$checked': {
            color: '#db5f8e',
        },
    },
    checked: {},
    disabled: {
        color: '#00000042 !important',
    },
}))
